// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-illustration {
  position: absolute;
  width: 80%;
  height: 80%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}

.login-illustration p {
  font-weight: bold;
  font-size: 20pt;
  color: black;
  margin-top: 30px;
}

.login-dot-effect {
  position: absolute;
  left: 80pt;
  top: 0;
}

.login-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.login-bg {
  /* background: linear-gradient(158.99deg, #0c2fde -18.54%, #0cb7ce 112.4%); */
  background-color: white;
}

.login-page {
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  margin: 0 0 0 0 !important;
  overflow-x: hidden;
}

.login-card {
  border-radius: 20px;
  width: 25rem;
  padding: 28px 28px 28px 28px;
  z-index: 200;
  margin-left: 10rem;
}

.login-corner-left {
  width: 35%;
  height: 35%;
  position: absolute;
  left: -20pt;
  bottom: 0;
}

.btn-login {
  background-color: #f4273a !important;
  border: #f4273a;
  color: white;
}

.btn-login:hover {
  background-color: #f4273cd8 !important;
  border: #f4273cd8;
  color: white;
}

.login-corner-right {
  width: 35%;
  height: 35%;
  position: absolute;
  right: -110pt;
  top: -20pt;
}

.table-action {
  padding-left: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
}

.table-scroll {
  overflow-y: hidden;
  overflow-x: auto;
  min-height: 400px;
}

.fixed-column-parent {
  overflow: hidden;
}

.fixed-column {
  padding-right: 0 !important;
  /* box-shadow: 5px 0 5px -2px rgba(237, 237, 237, 0.8); */
}

.nfixed-column {
  padding-left: 0 !important;
}

.no-wrap {
  white-space: nowrap;
}

.card-bluesky {
  border-color: #4461f2 !important;
  background-color: #e4e8ff !important;
}

.card-bluesky-body {
  color: black;
}

.departement-circle {
  height: 25px;
  width: 25px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}

.table-icon {
  font-size: 20px !important;
}

.button-link {
  color: #4461f2 !important;
}

.login-logo {
  height: 6rem;
}

.custom-dropzone-text {
  font-size: 14pt;
  color: #4461f2 !important;
}

.table-empty-icon {
  font-size: 60pt;
}

.table-empty-text {
  font-size: 13pt;
}

.icon-option {
  font-size: 13pt;
  color: #4461f2;
}

.icon-option:hover {
  color: #4495f2;
}

.custom-invalid {
  color: #e85347;
  font-size: 11px;
  font-style: italic;
}

@media screen and (max-width: 1300px) {
  .login-card {
    border-radius: 20px;
    width: 25rem;
    padding: 28px 28px 28px 28px;
    z-index: 200;
    margin-left: 5rem;
  }
}

.badge {
  border-radius: 20px;
  font-size: 10px;
  padding: 1px 8px;
  font-style: italic;
  font-weight: 600;
  width: fit-content;
  /* color: white; */
}

.business-badge__a-club {
  background-color: #f4273a;
}

.business-badge__sucor {
  background-color: #164688;
}

.business-badge__a_shop {
  background-color: #facc15;
}

.business-badge__orbi {
  background: linear-gradient(90deg, #ae8625 0%, #f7ef8a 37.5%, #d2ac47 76.56%, #edc967 100%);
}

.business-badge__cat {
  background-color: #480c10;
}

.campaign-badge__instagram {
  color: white;
  background: linear-gradient(90deg, #ffd882 12.86%, #ff7733 35.55%, #e70d73 58.7%, #a02bb9 80.03%, #485dce 100%);
}

.campaign-badge__facebook {
  color: white;
  background-color: #3b5998;
}

.campaign-badge__youtube {
  color: white;
  background-color: #ff0000;
}

.campaign-badge__livechat {
  color: white;
  background-color: #4f46e5;
}

.status-badge__closing {
  background-color: #4ece10;
}

.status-badge__replied {
  background-color: #f28100;
}

.status-badge__unreplied {
  background-color: #c63128;
}

.status-badge__on_payment {
  background-color: #9747ff;
}

/* Dashboard */

.report-panel {
  display: flex;
  height: 100%;
  justify-content: space-between;
  align-items: center;
}

.report-panel-title {
  font-size: 50px;
}

.report-panel-title-medium {
  font-size: 25px;
}

.report-panel__trend__up {
  color: #4ece10;
}

.report-panel__trend__down {
  color: #c63128;
}

/* Campaign */

.link-modal-button-selector {
  width: 130px;
  margin: 0 20px;
  padding: 10px 0px;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: #b0b0b0;
  border-width: 1px;
  border-style: solid;
  border-radius: 8px;
  cursor: pointer;
}
.link-modal-button-selector:hover {
  border-color: #4461f2;
}

.copy-link-button {
  height: 25px;
  padding: 14px 14px;
  display: flex;
  align-items: center;
  background-color: #d9d9d9;
  color: black;
  cursor: pointer;
}

.selector-active {
  border-color: #4461f2;
}

.toast-component {
  position: fixed;
  z-index: 100;
  right: 0;
  top: 10px;
}

.toast-bell {
  font-size: 30px;
  margin-right: 20px;
}

.relation-channel {
  background-color: #f5f6fb;
  overflow-y: auto;
  border-top-left-radius: 4px 4px;
  border-bottom-left-radius: 4px 4px;
}

.relation-channel-list {
  display: flex;
  align-items: center;
  height: 30px;
  padding-left: 10px;
  cursor: pointer;
}

.relation-channel-list:hover {
  background-color: rgb(184, 222, 255);
}

.relation-channel-list.active {
  background-color: #4461f2 !important;
  color: white;
  font-weight: bold;
}

.kanban-icon {
  font-size: 18px;
}

.yellow-color {
  color: #ffac09;
}

/* Chatbot */

.chatbot_preview_text {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.chatbot_preview_image_container {
  display: flex;
  justify-content: center;
  color: #070f18;
}

.chatbot_preview_image {
  max-width: 400px;
  position: relative;
}

.chatbot_preview_container {
  position: absolute;
  left: 15px;
  max-width: 245px;
  top: 130px;
  max-height:680px;
  min-width: 200px;
  overflow:scroll;
}
.chatbot_welcome_preview {
  background-color: #fafafa;
  padding: 10px 16px;
  border-radius: 5px;
}

.chatbot_button_preview {
  margin-top: 10px;
  justify-content: space-between;
  display: flex;
  max-width: 200px;
  flex-wrap: wrap;
  gap: 10px;
}

.chatbot_preview_header_text {
  font-weight: 600;
}
.chatbot_button_item {
  font-style: italic;
  width: 100%;
  max-width: 95px;
  text-align: center;
  background-color: #fafafa;
  padding: 10px 16px;
  border-radius: 5px;
}

.chatbot_link_button {
  color: #4461f2;
}

.chatbot_preview_body_text {
  font-size: 14px;
  line-height: 21px;
}

.terms-chatbot-container {
  margin-top: 22px;
  display: flex;
  width: 100%;
  padding: 18.5px 32px;
  background-color: #e4e8ff;
  border: 1px solid #4461f2;
  border-radius: 8px;
  justify-content: space-between;
}

#form-file-upload {
  height: 16rem;

  max-width: 100%;
  text-align: center;
  position: relative;
}

#input-file-upload {
  display: none;
}

#label-file-upload {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 2px;
  border-radius: 1rem;
  border-style: dashed;
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.upload-button {
  cursor: pointer;
  padding: 0.25rem;
  font-size: 1rem;
  border: none;
  font-family: "Oswald", sans-serif;
  background-color: transparent;
}

.upload-button:hover {
  text-decoration-line: underline;
}
#label-file-upload.drag-active {
  background-color: #ffffff;
}
#drag-file-element {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 1rem;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}

.variable_button_container {
  display: flex;
  gap: 11px;
  margin-top: 5px;
}
.variable_button {
  line-height: 24px;
  border: none;
  color: #6f6f6f;
  font-size: 16px;
  background: #e8e8e8;
  border-radius: 5px;
  padding: 10px 20px;
}

.form-subtitle {
  margin-top: -10px;
  color: #b0b0b0;
}

.button_options_container {
  border: 1px solid #dbdfea;
  border-radius: 5px;
  padding: 20px 15px;
  margin-top: 10px;
  width: 100%;
}

.quickreply_button_container {
  display: flex;
  align-items: center;
}

.another_button {
  line-height: 24px;
  border: none;
  color: white;
  font-size: 16px;
  background: #656565;
  border-radius: 5px;
  padding: 10px 20px;
  margin-top: 20px;
}

.ticket-simplebar .simplebar-content-wrapper {
  min-height: 400px;
}

.role_search_input {
  width: 150px;
}

.role_search_input_container {
  display: flex;
  gap: 10px;
}

.tooltip-ticket-sorting{
  display: flex;
  flex-direction: column;
  padding: 10px 0;
}

.filter-item {
  position: relative;
  margin-right: 20px;
}
.dropdown.show .filter-item-wrap {
  display: block;
}
.filter-item-wrap {
  max-height: 400px;
  overflow-y: auto;
  max-width: 300px;
  padding: 30px;
  position: absolute;
    z-index: 1;
    top: 50px;
    display: none;
}

.input-filter {
  width:200px;
}

.filter-opt {
  width: 200px;
  padding-left: 20px;
}

.data-filter-leads {
  margin-top: 20px;
}

.checkbox-input {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

/* Upload csv contact page */
.errorReport {
  max-height: 500px;
  overflow: auto;
}

.errorReport p {
  margin-bottom: 5px;
}

.contactCheckbox {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.contact_list_sync {
  display: flex;
  flex-wrap: wrap;
  max-height: 100px;
  flex-direction: column;
}

.resolve-prevent {
  display: block;
  text-align: center;
}
/* header account initials: base .user-avatar font-size (44px) is sized for the icon */
.user-toggle .user-avatar > span {
  font-size: 16px;
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/custom.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;AACR;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,6EAA6E;EAC7E,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;IACZ,4BAA4B;IAC5B,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2FAA2F;AAC7F;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,+GAA+G;AACjH;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;;AAEd;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,aAAa;;AAEb;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;;AAEZ;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;;EAEb,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;AACV;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA,sFAAsF;AACtF;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":[".login-illustration {\r\n  position: absolute;\r\n  width: 80%;\r\n  height: 80%;\r\n  left: 0;\r\n  right: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  margin: auto;\r\n}\r\n\r\n.login-illustration p {\r\n  font-weight: bold;\r\n  font-size: 20pt;\r\n  color: black;\r\n  margin-top: 30px;\r\n}\r\n\r\n.login-dot-effect {\r\n  position: absolute;\r\n  left: 80pt;\r\n  top: 0;\r\n}\r\n\r\n.login-col {\r\n  padding-left: 0 !important;\r\n  padding-right: 0 !important;\r\n}\r\n\r\n.login-bg {\r\n  /* background: linear-gradient(158.99deg, #0c2fde -18.54%, #0cb7ce 112.4%); */\r\n  background-color: white;\r\n}\r\n\r\n.login-page {\r\n  width: 100vw;\r\n  height: 100vh;\r\n  max-width: 100vw;\r\n  max-height: 100vh;\r\n  margin: 0 0 0 0 !important;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.login-card {\r\n  border-radius: 20px;\r\n  width: 25rem;\r\n  padding: 28px 28px 28px 28px;\r\n  z-index: 200;\r\n  margin-left: 10rem;\r\n}\r\n\r\n.login-corner-left {\r\n  width: 35%;\r\n  height: 35%;\r\n  position: absolute;\r\n  left: -20pt;\r\n  bottom: 0;\r\n}\r\n\r\n.btn-login {\r\n  background-color: #f4273a !important;\r\n  border: #f4273a;\r\n  color: white;\r\n}\r\n\r\n.btn-login:hover {\r\n  background-color: #f4273cd8 !important;\r\n  border: #f4273cd8;\r\n  color: white;\r\n}\r\n\r\n.login-corner-right {\r\n  width: 35%;\r\n  height: 35%;\r\n  position: absolute;\r\n  right: -110pt;\r\n  top: -20pt;\r\n}\r\n\r\n.table-action {\r\n  padding-left: 0 !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: flex-start !important;\r\n}\r\n\r\n.table-scroll {\r\n  overflow-y: hidden;\r\n  overflow-x: auto;\r\n  min-height: 400px;\r\n}\r\n\r\n.fixed-column-parent {\r\n  overflow: hidden;\r\n}\r\n\r\n.fixed-column {\r\n  padding-right: 0 !important;\r\n  /* box-shadow: 5px 0 5px -2px rgba(237, 237, 237, 0.8); */\r\n}\r\n\r\n.nfixed-column {\r\n  padding-left: 0 !important;\r\n}\r\n\r\n.no-wrap {\r\n  white-space: nowrap;\r\n}\r\n\r\n.card-bluesky {\r\n  border-color: #4461f2 !important;\r\n  background-color: #e4e8ff !important;\r\n}\r\n\r\n.card-bluesky-body {\r\n  color: black;\r\n}\r\n\r\n.departement-circle {\r\n  height: 25px;\r\n  width: 25px;\r\n  background-color: #bbb;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n}\r\n\r\n.table-icon {\r\n  font-size: 20px !important;\r\n}\r\n\r\n.button-link {\r\n  color: #4461f2 !important;\r\n}\r\n\r\n.login-logo {\r\n  height: 6rem;\r\n}\r\n\r\n.custom-dropzone-text {\r\n  font-size: 14pt;\r\n  color: #4461f2 !important;\r\n}\r\n\r\n.table-empty-icon {\r\n  font-size: 60pt;\r\n}\r\n\r\n.table-empty-text {\r\n  font-size: 13pt;\r\n}\r\n\r\n.icon-option {\r\n  font-size: 13pt;\r\n  color: #4461f2;\r\n}\r\n\r\n.icon-option:hover {\r\n  color: #4495f2;\r\n}\r\n\r\n.custom-invalid {\r\n  color: #e85347;\r\n  font-size: 11px;\r\n  font-style: italic;\r\n}\r\n\r\n@media screen and (max-width: 1300px) {\r\n  .login-card {\r\n    border-radius: 20px;\r\n    width: 25rem;\r\n    padding: 28px 28px 28px 28px;\r\n    z-index: 200;\r\n    margin-left: 5rem;\r\n  }\r\n}\r\n\r\n.badge {\r\n  border-radius: 20px;\r\n  font-size: 10px;\r\n  padding: 1px 8px;\r\n  font-style: italic;\r\n  font-weight: 600;\r\n  width: fit-content;\r\n  /* color: white; */\r\n}\r\n\r\n.business-badge__a-club {\r\n  background-color: #f4273a;\r\n}\r\n\r\n.business-badge__sucor {\r\n  background-color: #164688;\r\n}\r\n\r\n.business-badge__a_shop {\r\n  background-color: #facc15;\r\n}\r\n\r\n.business-badge__orbi {\r\n  background: linear-gradient(90deg, #ae8625 0%, #f7ef8a 37.5%, #d2ac47 76.56%, #edc967 100%);\r\n}\r\n\r\n.business-badge__cat {\r\n  background-color: #480c10;\r\n}\r\n\r\n.campaign-badge__instagram {\r\n  color: white;\r\n  background: linear-gradient(90deg, #ffd882 12.86%, #ff7733 35.55%, #e70d73 58.7%, #a02bb9 80.03%, #485dce 100%);\r\n}\r\n\r\n.campaign-badge__facebook {\r\n  color: white;\r\n  background-color: #3b5998;\r\n}\r\n\r\n.campaign-badge__youtube {\r\n  color: white;\r\n  background-color: #ff0000;\r\n}\r\n\r\n.campaign-badge__livechat {\r\n  color: white;\r\n  background-color: #4f46e5;\r\n}\r\n\r\n.status-badge__closing {\r\n  background-color: #4ece10;\r\n}\r\n\r\n.status-badge__replied {\r\n  background-color: #f28100;\r\n}\r\n\r\n.status-badge__unreplied {\r\n  background-color: #c63128;\r\n}\r\n\r\n.status-badge__on_payment {\r\n  background-color: #9747ff;\r\n}\r\n\r\n/* Dashboard */\r\n\r\n.report-panel {\r\n  display: flex;\r\n  height: 100%;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.report-panel-title {\r\n  font-size: 50px;\r\n}\r\n\r\n.report-panel-title-medium {\r\n  font-size: 25px;\r\n}\r\n\r\n.report-panel__trend__up {\r\n  color: #4ece10;\r\n}\r\n\r\n.report-panel__trend__down {\r\n  color: #c63128;\r\n}\r\n\r\n/* Campaign */\r\n\r\n.link-modal-button-selector {\r\n  width: 130px;\r\n  margin: 0 20px;\r\n  padding: 10px 0px;\r\n  height: 120px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  border: #b0b0b0;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n}\r\n.link-modal-button-selector:hover {\r\n  border-color: #4461f2;\r\n}\r\n\r\n.copy-link-button {\r\n  height: 25px;\r\n  padding: 14px 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: #d9d9d9;\r\n  color: black;\r\n  cursor: pointer;\r\n}\r\n\r\n.selector-active {\r\n  border-color: #4461f2;\r\n}\r\n\r\n.toast-component {\r\n  position: fixed;\r\n  z-index: 100;\r\n  right: 0;\r\n  top: 10px;\r\n}\r\n\r\n.toast-bell {\r\n  font-size: 30px;\r\n  margin-right: 20px;\r\n}\r\n\r\n.relation-channel {\r\n  background-color: #f5f6fb;\r\n  overflow-y: auto;\r\n  border-top-left-radius: 4px 4px;\r\n  border-bottom-left-radius: 4px 4px;\r\n}\r\n\r\n.relation-channel-list {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 30px;\r\n  padding-left: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.relation-channel-list:hover {\r\n  background-color: rgb(184, 222, 255);\r\n}\r\n\r\n.relation-channel-list.active {\r\n  background-color: #4461f2 !important;\r\n  color: white;\r\n  font-weight: bold;\r\n}\r\n\r\n.kanban-icon {\r\n  font-size: 18px;\r\n}\r\n\r\n.yellow-color {\r\n  color: #ffac09;\r\n}\r\n\r\n/* Chatbot */\r\n\r\n.chatbot_preview_text {\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  line-height: 24px;\r\n}\r\n\r\n.chatbot_preview_image_container {\r\n  display: flex;\r\n  justify-content: center;\r\n  color: #070f18;\r\n}\r\n\r\n.chatbot_preview_image {\r\n  max-width: 400px;\r\n  position: relative;\r\n}\r\n\r\n.chatbot_preview_container {\r\n  position: absolute;\r\n  left: 15px;\r\n  max-width: 245px;\r\n  top: 130px;\r\n  max-height:680px;\r\n  min-width: 200px;\r\n  overflow:scroll;\r\n}\r\n.chatbot_welcome_preview {\r\n  background-color: #fafafa;\r\n  padding: 10px 16px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.chatbot_button_preview {\r\n  margin-top: 10px;\r\n  justify-content: space-between;\r\n  display: flex;\r\n  max-width: 200px;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n}\r\n\r\n.chatbot_preview_header_text {\r\n  font-weight: 600;\r\n}\r\n.chatbot_button_item {\r\n  font-style: italic;\r\n  width: 100%;\r\n  max-width: 95px;\r\n  text-align: center;\r\n  background-color: #fafafa;\r\n  padding: 10px 16px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.chatbot_link_button {\r\n  color: #4461f2;\r\n}\r\n\r\n.chatbot_preview_body_text {\r\n  font-size: 14px;\r\n  line-height: 21px;\r\n}\r\n\r\n.terms-chatbot-container {\r\n  margin-top: 22px;\r\n  display: flex;\r\n  width: 100%;\r\n  padding: 18.5px 32px;\r\n  background-color: #e4e8ff;\r\n  border: 1px solid #4461f2;\r\n  border-radius: 8px;\r\n  justify-content: space-between;\r\n}\r\n\r\n#form-file-upload {\r\n  height: 16rem;\r\n\r\n  max-width: 100%;\r\n  text-align: center;\r\n  position: relative;\r\n}\r\n\r\n#input-file-upload {\r\n  display: none;\r\n}\r\n\r\n#label-file-upload {\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-width: 2px;\r\n  border-radius: 1rem;\r\n  border-style: dashed;\r\n  border-color: #cbd5e1;\r\n  background-color: #f8fafc;\r\n}\r\n\r\n.upload-button {\r\n  cursor: pointer;\r\n  padding: 0.25rem;\r\n  font-size: 1rem;\r\n  border: none;\r\n  font-family: \"Oswald\", sans-serif;\r\n  background-color: transparent;\r\n}\r\n\r\n.upload-button:hover {\r\n  text-decoration-line: underline;\r\n}\r\n#label-file-upload.drag-active {\r\n  background-color: #ffffff;\r\n}\r\n#drag-file-element {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 1rem;\r\n  top: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n}\r\n\r\n.variable_button_container {\r\n  display: flex;\r\n  gap: 11px;\r\n  margin-top: 5px;\r\n}\r\n.variable_button {\r\n  line-height: 24px;\r\n  border: none;\r\n  color: #6f6f6f;\r\n  font-size: 16px;\r\n  background: #e8e8e8;\r\n  border-radius: 5px;\r\n  padding: 10px 20px;\r\n}\r\n\r\n.form-subtitle {\r\n  margin-top: -10px;\r\n  color: #b0b0b0;\r\n}\r\n\r\n.button_options_container {\r\n  border: 1px solid #dbdfea;\r\n  border-radius: 5px;\r\n  padding: 20px 15px;\r\n  margin-top: 10px;\r\n  width: 100%;\r\n}\r\n\r\n.quickreply_button_container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.another_button {\r\n  line-height: 24px;\r\n  border: none;\r\n  color: white;\r\n  font-size: 16px;\r\n  background: #656565;\r\n  border-radius: 5px;\r\n  padding: 10px 20px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.ticket-simplebar .simplebar-content-wrapper {\r\n  min-height: 400px;\r\n}\r\n\r\n.role_search_input {\r\n  width: 150px;\r\n}\r\n\r\n.role_search_input_container {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.tooltip-ticket-sorting{\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 10px 0;\r\n}\r\n\r\n.filter-item {\r\n  position: relative;\r\n  margin-right: 20px;\r\n}\r\n.dropdown.show .filter-item-wrap {\r\n  display: block;\r\n}\r\n.filter-item-wrap {\r\n  max-height: 400px;\r\n  overflow-y: auto;\r\n  max-width: 300px;\r\n  padding: 30px;\r\n  position: absolute;\r\n    z-index: 1;\r\n    top: 50px;\r\n    display: none;\r\n}\r\n\r\n.input-filter {\r\n  width:200px;\r\n}\r\n\r\n.filter-opt {\r\n  width: 200px;\r\n  padding-left: 20px;\r\n}\r\n\r\n.data-filter-leads {\r\n  margin-top: 20px;\r\n}\r\n\r\n.checkbox-input {\r\n  margin-right: 10px;\r\n  position: relative;\r\n  top: 2px;\r\n}\r\n\r\n/* Upload csv contact page */\r\n.errorReport {\r\n  max-height: 500px;\r\n  overflow: auto;\r\n}\r\n\r\n.errorReport p {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.contactCheckbox {\r\n  display: flex;\r\n  justify-content: space-evenly;\r\n  align-items: center;\r\n}\r\n\r\n.contact_list_sync {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  max-height: 100px;\r\n  flex-direction: column;\r\n}\r\n\r\n.resolve-prevent {\r\n  display: block;\r\n  text-align: center;\r\n}\r\n/* header account initials: base .user-avatar font-size (44px) is sized for the icon */\r\n.user-toggle .user-avatar > span {\r\n  font-size: 16px;\r\n  line-height: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
